import { useState } from "react";
import { Authlogin } from "../api";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
export default function Login() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await Authlogin({
        email: formData.email,
        password: formData.password,
      });

      const { user, token } = response.data;

      login(user, token);

      alert("Login Successful");

      if (user.role === "admin") {
        navigate("/dashboard");
      } else if (user.role === "buyer") {
        navigate("/buyer");
      }
    } catch (error) {
      console.log(error);
      alert(error.response?.data?.message || "Login Failed");
    }
  };
  return (
   <div className="md:min-h-screen bg-gray-100 px-4 pt-6 pb-8 md:flex md:items-center md:justify-center">
  <div className="w-full max-w-md mx-auto bg-white shadow-lg rounded-2xl p-5 sm:p-6 md:p-8">
    {/* Header */}
    <div className="text-center">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
        Welcome Back
      </h1>

      <p className="text-sm sm:text-base text-gray-500 mt-2">
        Login to your account
      </p>
    </div>


        {/* Form */}
        <form onSubmit={handleSubmit} className="mt-6 sm:mt-8">
          <div className="mb-4 sm:mb-5">
            <label className="block text-gray-700 mb-2 text-sm sm:text-base">
              Email Address
            </label>

            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          <div className="mb-4 sm:mb-5">
            <label className="block text-gray-700 mb-2 text-sm sm:text-base">
              Password
            </label>

            <input
              type="password"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-green-500"
              required
            />
          </div>

          {/* Remember & Forgot */}
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-6">
            <label className="flex items-center gap-2 text-sm text-gray-600">
              <input type="checkbox" />
              Remember me
            </label>

            <a
              href="/forgot-password"
              className="text-sm text-green-600 hover:underline"
            >
              Forgot Password?
            </a>
          </div>

          {/* Button */}
          <button
            type="submit"
            className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-medium transition"
          >
            Login
          </button>
        </form>

      {/* Footer */}
    <p className="text-center text-sm sm:text-base text-gray-600 mt-6">
      Don't have an account?{" "}
      <a
        href="/register"
        className="text-green-600 font-medium hover:underline"
      >
        Sign Up
      </a>
    </p>
  </div>
</div>
  );
}
